import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pay"
  }, [_vm.paid == 1 ? _c("div", {
    staticClass: "paid"
  }, [_c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, [_vm.overTime ? _c("img", {
    attrs: {
      src: require("../../../assets/error.png"),
      alt: ""
    }
  }) : _c("img", {
    attrs: {
      src: require("../../../assets/pay.png"),
      alt: ""
    }
  }), _c("span", {
    staticStyle: {
      width: "calc(100% - 40px)",
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.overTime ? _vm.$t("支付超时") : _vm.$t("支付成功")) + "！")]), _c("div", {
    staticStyle: {
      margin: "20px 0 0 40px"
    }
  }, [_vm.overTime ? _c("span", [_vm._v(_vm._s(_vm.$t("该笔支付信息超出支付时间已自动取消")) + "， ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("点击跳转至")) + " "), _c("span", {
    staticStyle: {
      color: "#1890ff",
      "text-decoration": "underline",
      cursor: "pointer"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "customListManage"
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("支付列表")))])])])]) : _vm._e(), _vm.paid == 2 ? _c("div", [_c("h3", [_vm._v(_vm._s(_vm.$t("信息已经提交，请尽快支付！")))]), _c("div", [_vm._v(_vm._s(_vm.$t("请您在") + _vm.minute + _vm.$t("分钟") + _vm.second + _vm.$t("秒") + _vm.$t("内支付，否则订单会被自动取消")))]), _c("div", {
    staticClass: "code"
  }, [_vm.payMethod ? _c("div", {
    staticClass: "method"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("支付方式")) + ":")]), _vm.payMethod == "WECHAT" ? _c("div", {
    staticClass: "item"
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/wxpay.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.$t("微信支付")))])]) : _vm.payMethod == "ALIPAY" ? _c("div", {
    staticClass: "item"
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/zfb.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.$t("支付宝支付")))])]) : _vm._e()]) : _vm._e(), _c("div", {
    staticClass: "show-code"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("扫一扫支付")))]), _c("span", {
    staticStyle: {
      "font-weight": "700",
      margin: "30px 0"
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")]), _c("div", {
    ref: "qrcode"
  })])])]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };